import { render, staticRenderFns } from "./equityAllocationIP.vue?vue&type=template&id=79941f67&scoped=true"
import script from "./equityAllocationIP.vue?vue&type=script&lang=js"
export * from "./equityAllocationIP.vue?vue&type=script&lang=js"
import style0 from "./equityAllocationIP.vue?vue&type=style&index=0&id=79941f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79941f67",
  null
  
)

export default component.exports